import { RouteInfo } from './adminsidebar.metadata';

export const ROUTES: RouteInfo[] = [
  //   {
  //     path: '',
  //     title: 'Personal',
  //     icon: 'mdi mdi-dots-horizontal',
  //     class: 'nav-small-cap',
  //     extralink: true,
  //     submenu: []
  //   },
    {
      path: '/admin/kyc',
      title: 'Dashboard',
      icon: 'icon-Dashboard',
      class: '',
      extralink: false,
      submenu: []
    },
    {
      path: '/admin/distributor',
      // title: 'Distributor & Lender',
      title: 'Anchor & Lender',
      icon: 'icon-Books-2',
      class: '',
      extralink: false,
      submenu: []
    },
    {
      path: '/admin/users',
      title: 'Users',
      icon: 'fas fa-users',
      class: '',
      extralink: false,
      submenu: []
    },
    {
      path: '/admin/channel',
      title: 'Channel Partner',
      icon: 'icon-Mailbox-Full',
      class: '',
      extralink: false,
      submenu: []
    },
    {
      path: '/admin/rm',
      title: 'Relationship Manager',
      icon: 'icon-Bar-Chart',
      class: '',
      extralink: false,
      submenu: []
    },
    {
      path: '/admin/super-admin',
      title: 'Super Admin',
      icon: 'icon-Bar-Chart',
      class: '',
      extralink: false,
      submenu: []
    },
    {
      path: '/admin/lender',
      title: 'Lender',
      icon: 'icon-Bank',
      class: '',
      extralink: false,
      submenu: []
    },
    // {
    //   path: '/buyer/po',
    //   title: 'Purchase Order',
    //   icon: 'icon-Full-Cart',
    //   class: '',
    //   extralink: false,
    //   submenu: []
    // },
    // {
    //   path: '/buyer/invoice',
    //   title: 'Invoice',
    //   icon: 'icon-Receipt-3',
    //   class: '',
    //   extralink: false,
    //   submenu: []
    // }
  ];
